/* ================== PERSONALIZATION CONTROLLER (idempotent) ================== */
/* Set your $6 add-on VARIANT id. Use 0 to disable the charge while testing.     */
if (!window.__PERSONALIZATION_BOOTED__) {
  window.__PERSONALIZATION_BOOTED__ = true;

  // >>> set to 0 first to stabilize, then put your real variant id back
  window.ADDON_VARIANT_ID = 0; // 10139355742530;

  (function () {

    /* ---------- helpers ---------- */
    function getForm() {
      const btn = document.querySelector('button[name="add"], product-form button[type="submit"]');
      return (btn && btn.closest('form')) ||
             document.querySelector('product-form form') ||
             document.querySelector('form[action*="/cart/add"]') ||
             document.querySelector('form[action*="cart/add"]');
    }

    function ensureHidden(form) {
      if (!form) return null;
      [
        ['prop-decoration','properties[Decoration Type]'],
        ['prop-add-name',  'properties[Personalization]'],
        ['prop-name',      'properties[Name to Appear]'],
        ['prop-font',      'properties[Font Style]']
      ].forEach(([id,name])=>{
        if (!form.querySelector('#'+id)) {
          const el=document.createElement('input');
          el.type='hidden'; el.id=id; el.name=name; form.appendChild(el);
        }
      });
      return {
        propDecoration: form.querySelector('#prop-decoration'),
        propAdd:        form.querySelector('#prop-add-name'),
        propName:       form.querySelector('#prop-name'),
        propFont:       form.querySelector('#prop-font')
      };
    }

    // super-tolerant UI discovery (id, name, placeholder, label)
    function inputByLabel(rx){
      const lbl = Array.from(document.querySelectorAll('label')).find(l => rx.test(l.textContent||''));
      if (!lbl) return null;
      const forId = lbl.getAttribute('for');
      if (forId) { const el = document.getElementById(forId); if (el && el.tagName==='INPUT') return el; }
      let n = lbl.nextElementSibling; while (n) { if (n.tagName==='INPUT') return n; n = n.nextElementSibling; }
      return null;
    }
    function ui(){
      const addSel =
        document.getElementById('ui-add-name') ||
        document.getElementById('personalization') ||
        Array.from(document.querySelectorAll('select')).find(s =>
          Array.from(s.options).some(o => /Add Name/i.test(o.text))
        );

      const nameIn =
        document.getElementById('ui-name') ||
        document.querySelector('input[name="properties[Name to Appear]"]') ||
        Array.from(document.querySelectorAll('input')).find(i =>
          /name to appear/i.test(i.name||'') || /name to appear/i.test(i.placeholder||'')
        ) || inputByLabel(/name to appear/i);

      const fontIn =
        document.getElementById('ui-font') ||
        document.querySelector('input[name="properties[Font Style]"]') ||
        Array.from(document.querySelectorAll('input')).find(i =>
          /font style/i.test(i.name||'') || /font/i.test(i.placeholder||'')
        ) || inputByLabel(/font style/i);

      const deco =
        document.getElementById('ui-decoration-type') ||
        document.querySelector('input[name="properties[Decoration Type]"]') ||
        inputByLabel(/decoration type/i);

      return { addSel, nameIn, fontIn, deco,
               nameWrap: document.getElementById('ui-name-wrap'),
               fontWrap: document.getElementById('ui-font-wrap') };
    }

    const wantsName = addSel => !!(addSel && String(addSel.value).trim().toLowerCase() !== 'no');

    function applyVisibility(on, nameWrap, fontWrap){
      if (nameWrap) nameWrap.style.display = on ? '' : 'none';
      if (fontWrap)  fontWrap.style.display = on ? '' : 'none';
    }

    function sync() {
      const form = getForm(); const props = ensureHidden(form); if (!props) return;
      const { deco, addSel, nameWrap, fontWrap, nameIn, fontIn } = ui();
      const on = wantsName(addSel);
      applyVisibility(on, nameWrap, fontWrap);

      if (props.propDecoration) props.propDecoration.value = deco && deco.value != null ? String(deco.value) : '';
      if (props.propAdd)        props.propAdd.value        = addSel ? String(addSel.value) : 'No';
      if (props.propName)       props.propName.value       = on ? (nameIn && nameIn.value != null ? String(nameIn.value) : '') : '';
      if (props.propFont)       props.propFont.value       = on ? (fontIn && fontIn.value != null ? String(fontIn.value) : '') : '';
    }

    // only read our hidden inputs so nothing else overrides
    function buildMainItem(form){
      const fd = new FormData(form);
      const item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity')||'1', 10) };
      const props = {
        'Decoration Type': form.querySelector('#prop-decoration')?.value || '',
        'Personalization': form.querySelector('#prop-add-name')?.value || 'No',
        'Name to Appear':  form.querySelector('#prop-name')?.value || '',
        'Font Style':      form.querySelector('#prop-font')?.value || ''
      };
      const filtered = {};
      Object.keys(props).forEach(k => { if (props[k] !== '') filtered[k] = props[k]; });
      if (Object.keys(filtered).length) item.properties = filtered;
      return item;
    }

    async function addOne(item){
      const r = await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify(item)
      });
      if (!r.ok) throw new Error(await r.text());
      return r.json();
    }

    // remove legacy duplicate fields that could override ours
    function scrubDuplicates(){
      const form = getForm(); if (!form) return;
      ['Personalization','Name to Appear','Font Style','Decoration Type'].forEach(label => {
        form.querySelectorAll(`[name="properties[${label}]"]`).forEach(n => {
          if (!/^prop-/.test(n.id||'')) n.remove();
        });
      });
    }

    // idempotent bind — attach once per form
    function bind(){
      const form = getForm(); if (!form) return;
      if (form.__pzBound) return; // prevent multiple bindings
      form.__pzBound = true;

      // live UI sync
      document.addEventListener('variant:change', sync);
      document.addEventListener('shopify:section:load', () => { sync(); scrubDuplicates(); });

      const { addSel, nameIn, fontIn } = ui();
      addSel && addSel.addEventListener('change', sync, {passive:true});
      nameIn && nameIn.addEventListener('input',  sync, {passive:true});
      fontIn && fontIn.addEventListener('input',  sync, {passive:true});

      // just-in-time sync on click
      document.addEventListener('click',(e)=>{
        if (e.target.closest('button[name="add"], product-form button[type="submit"]')) { sync(); scrubDuplicates(); }
      }, true);

      // submit – always add main; add-on is best-effort; no duplicates
      form.addEventListener('submit', async (e)=>{
        const s = e.submitter || document.activeElement;
        if (!(s && (s.name==='add' || s.type==='submit'))) return;
        e.preventDefault(); sync(); scrubDuplicates();

        try {
          const main = buildMainItem(form);
          await addOne(main); // main must succeed

          if (wantsName(ui().addSel) && Number(window.ADDON_VARIANT_ID)) {
            // add-on is optional, does not block cart
            try {
              await addOne({ id: Number(window.ADDON_VARIANT_ID), quantity: main.quantity,
                             properties: { '_linked_to': main.properties?.['Name to Appear'] || 'Personalization' } });
            } catch (err) { console.warn('Add-on failed (ignored):', err); }
          }

          const btn = document.querySelector('[data-cart-toggle], button[aria-controls="CartDrawer"]');
          if (btn) btn.click(); else location.href = '/cart';
        } catch (err) {
          alert('Could not add item: ' + err.message);
        }
      }, true);
    }

    // single observer to recover after dynamic swaps, but binding is idempotent
    const mo = new MutationObserver(() => { sync(); bind(); });
    mo.observe(document.documentElement, { childList:true, subtree:true });

    document.addEventListener('DOMContentLoaded', () => { sync(); bind(); });
  })();
}
/* ================== end controller ================== */
